import { amenityIconPaths } from "./amenity-icon-paths"
import { unitIconPaths } from "./unit-icon-paths"
import { openingIconPaths } from "./opening-icon-paths"
import { occupantIconPaths } from "./occupant-icon-paths"
import { sectionIconPaths } from "./section-icon-paths"

export const iconsPathStrings: Record<string, string> = {
  ...amenityIconPaths,
  ...unitIconPaths,
  ...openingIconPaths,
  ...occupantIconPaths,
  ...sectionIconPaths,
}

export const getIconPathString = (feature: string): string | null =>
  iconsPathStrings[feature] || null
